import { createFileRoute, notFound } from "@tanstack/react-router";

import { BlogIndexView } from "@/components/pages/BlogIndexView";
import { meta } from "@/content/meta";
import { isLocale } from "@/i18n/locales";
import { seoHead } from "@/lib/site";

export const Route = createFileRoute("/$locale/blog/")({
  head: ({ params }) =>
    isLocale(params.locale)
      ? seoHead({
          locale: params.locale,
          path: "/blog",
          ...meta[params.locale].blog,
        })
      : {},
  component: BlogIndexRoute,
});

function BlogIndexRoute() {
  const { locale } = Route.useParams();
  if (!isLocale(locale)) throw notFound();
  return <BlogIndexView locale={locale} />;
}
